/**
 *  AppShell script file
**/

import MapComponent from '@/components/map-component/MapComponent.vue'
import SankeyComponent from '@/components/sankey-component/SankeyComponent.vue'
import EvolutionComponent from '@/components/evolution-component/EvolutionComponent.vue'
import Accordion from '@/components/accordion/Accordion.vue'

export default {
  name: 'AppShell',
  mixins: [],
  components: {
    MapComponent,
    SankeyComponent,
    EvolutionComponent,
    AccordionComponent: Accordion
  },
  props: {},
  data () {
    return {
      loaded: false,
      // id: this.$root.$data.id,
      config: this.$root.$data.config,
      data: this.$root.$data.data,
      component: this.$root.$data.component
    }
  },
  computed: {
    element () {
      return `${this.component}Component`
    },
    properties () {
      return {
        config: this.config,
        data: this.data
      }
    }
  },
  methods: {
  }
}
